const langId = {
  HEADER_TITLE: "HEADER_TITLE",
  PREVIOUS_ISSUES: "PREVIOUS_ISSUES",
  LINK_REIT: "LINK_REIT",
  CHANNEL_823: "CHANNEL_823",
  HOME: "HOME",
  CEOS_VIEWS: "CEOS_VIEWS",
  CORPORATE_NEWS: "CORPORATE_NEWS",
  FEATURE_STORIES: "FEATURE_STORIES",
  LINK_TOGETHER_INITIATIVES: "LINK_TOGETHER_INITIATIVES",
  THE_LINK_MOMENTS: "THE_LINK_MOMENTS",
  CLOSE: "CLOSE",
  MENU: "MENU",
  COPYRIGHT_DISCLAIMER: "COPYRIGHT_DISCLAIMER",
  ALL_RIGHT_RESERVED: "ALL_RIGHT_RESERVED",
  LINKEDIN: "LINKEDIN",
  TWITTER: "TWITTER",
  FACEBOOK: "FACEBOOK",
  INSTAGRAM: "INSTAGRAM",
  YOUTUBE: "YOUTUBE",
  WEIBO: "WEIBO",
  WECHAT: "WECHAT",
  SCAN_IN_WECHAT: "SCAN_IN_WECHAT",
  LINKS_WECHAT_PAGE: "LINKS_WECHAT_PAGE",
  LINKS_WEIBO_PAGE: "LINKS_WEIBO_PAGE",
  COVER: "COVER",
  BACK_TO_TOP: "BACK_TO_TOP",
  TOP: "TOP",
  LINK_REIT_WECHAT_QR_CODE: "LINK_REIT_WECHAT_QR_CODE",
  STORY1: "STORY1",
  STORY2: "STORY2",
  STORY3: "STORY3",
  COVER_IMG_TITLE: "COVER_IMG_TITLE",
  READ_MORE: "READ_MORE",
}
export default langId
